import { BaseReducer } from '@hobs/utils/baseReducer';
import { list } from '@hobs/constants/odata';

class OData extends BaseReducer {
  static defaultState = {
    data: [],
    total: 0
  };

  constructor() {
    super(OData.defaultState);
    this.actionMap = {
      [list.SUCCESS]: this.loadODataList,
      [list.RESET]: this.resetODataList
    };
  }

  loadODataList = (state, action) => {
    return Object.assign({}, state, action.payload);
  };

  resetODataList = () => {
    return OData.defaultState;
  };
}
export default new OData().reducer;
